// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container.padding[data-v-56dd78f6]{padding-bottom:15rem}@media (max-width:767px){.home-container.padding[data-v-56dd78f6]{padding-bottom:17rem}}", ""]);
// Exports
module.exports = exports;
